import React from 'react';
import sdcLogo from '../../assets/images/sdc-logo.png';
import deloitteLogo  from '../../assets/images/deloitte-logo.png';
import foodLogistics  from '../../assets/images/food-logistics-logo.png';
import bestBiz from '../../assets/images/bestbiz-logo.png';

const Partnership = () => {
  return (  
    <div>
      <div className="container partnership">
        <div className="text-center">
          <p className="text-primary fs-36">Partnerships/ Associations</p>
          <p className="text-gray fs-15 mb-5">Our Journey is fueled with innovative and intelligent transport solutions for<br></br> fleets, that have driven us to great distances.</p>
        </div>
        <div className="row mt-5">
          <div className="col-md-3 partner">
            <img src={sdcLogo} alt="SDC Logo" />
          </div>
          <div className="col-md-3 partner">
            <img src={deloitteLogo} alt="Deloitte Logo" />
          </div>
          <div className="col-md-3 partner">
            <img src={foodLogistics} alt="Food Logistics Logo" />
          </div>
          <div className="col-md-3 partner">
            <img src={bestBiz} alt="Best Biz Logo" />
          </div>
        </div>
      </div>
    </div>
  );
}
 
export default Partnership;